<div class="main-div">
    <p class="mainHeading">{{ 'RAINFALL-CAPTURE-DIALOG.CAPTURE-FOR' | translate }} {{ name }}</p>
    <hr />

    <form [formGroup]="rainfallForm" (ngSubmit)="onSubmit()">
        <div>
            <mat-form-field class="flex-100">
                <mat-label>{{ 'RAINFALL-CAPTURE-DIALOG.AMOUNT' | translate }}</mat-label>
                <input matInput type="text" formControlName="rainfallAmount">
                <mat-error *ngFor="let validation of validation_messages.rainfallAmount">
                    <mat-error class="error-message"
                        *ngIf="rainfallForm.get('rainfallAmount').hasError(validation.type) && 
                                        (rainfallForm.get('rainfallAmount').dirty || rainfallForm.get('rainfallAmount').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
        </div>
        <br />
        <div>
            <mat-form-field class="flex-100">
                <mat-label>{{ 'RAINFALL-CAPTURE-DIALOG.DESCRIPTION' | translate }}</mat-label>
                <input matInput type="text" formControlName="description">
                <mat-error *ngFor="let validation of validation_messages.description">
                    <mat-error class="error-message"
                        *ngIf="rainfallForm.get('description').hasError(validation.type) && 
                                        (rainfallForm.get('description').dirty || rainfallForm.get('description').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
        </div>
        <br />
        <div>
            <mat-form-field class="flex-100">
                <mat-label>{{ 'RAINFALL-CAPTURE-DIALOG.CLASSIFICATION' | translate }}</mat-label>
                <mat-select name="classification" formControlName="classification">
                    <mat-option *ngFor="let classification of rainfallClassifications" [value]="classification.name">
                        {{classification.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <br />
        <div>
            <mat-form-field>
                <mat-label>{{ 'RAINFALL-CAPTURE-CAPTURE-DATE' | translate }}</mat-label>
                <input readonly matInput [matDatepicker]="picker" formControlName="captureDate" (dateInput)="dateChanged($event)"> 
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngFor="let validation of validation_messages.captureDate">
                    <mat-error class="error-message"
                        *ngIf="rainfallForm.get('captureDate').hasError(validation.type) && 
                                        (rainfallForm.get('captureDate').dirty || rainfallForm.get('captureDate').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
        </div>


        <div class="flex-row justify-end gap-10">
            <button  mat-button type="button" (click)="closeDialog()">{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
            <button  mat-button type="submit">{{ 'RAINFALL-CAPTURE-DIALOG.CREATE' | translate }}</button>
        </div>
    </form>

    <hr />

    <div class="justify-center" *ngIf="isRainfallEmpty">
        <label>{{ 'RAINFALL-CAPTURE-DIALOG.NO-RAINFALL' | translate }}</label>
    </div>
    <div class="rainfall-list">
        <div *ngFor="let rainfall of rainfall" class="rainfall-div">
            <label class="rainfall-amount">{{ rainfall.rainfall }} mm</label>
            <br />
            <label> {{ rainfall.date_captured | date:'yyyy-MM-dd' }}</label>
        </div>
    </div>
</div>